// extracted by mini-css-extract-plugin
export var lg = "_3m-4";
export var md = "_3m-3";
export var sm = "_3m-2";
export var xs = "_3m-1";
export var xxs = "_3m-0";